import { createRequestActionTypes } from "../../../utils/request-actions-helpers/createRequestActionTypes"
import { FetchRequestActions } from "../../../utils/request-actions-helpers/createRequestActions"
import { Task } from "../../../models/Task"
import { TasksResults } from "./actions"

export const fetchFeedTasksActionTypes = createRequestActionTypes('FEED_TASKS')
export type TasksActions = FetchRequestActions<TasksResults>

export const toggleTaskStatusActionTypes = createRequestActionTypes('TOGGLE_TASK_STATUS')
export type UpdateTaskActions = FetchRequestActions<Task, Task>

export interface UpdateTaskAdditionalData {
    taskId: string,
    checklistUid: string
}